import React from "react";
import { createComponent } from "@lit/react";
import { RegistrationCancellation } from "../components/registration-cancellation/registration-cancellation.js";
import { SeasonInterruption } from "../components/season-interruption/season-interruption.js";
import { TicketRefund } from "../components/ticket-refund/ticket-refund.js";
import { ShippingInsurance } from "../components/shipping-insurance/shipping-insurance.js";
import { GapMedical } from "../components/gap-medical/gap-medical.js";
import { MultiOfferWrapperElement } from "../components/multi-offer/multi-offer.js";
import { PetInsurance } from "../components/pet-insurance/pet-insurance.js";
import { TuitionInsurance } from "../components/tuition-insurance/tuition-insurance.js";
import { TravelInsurance } from "../components/travel-insurance/travel-insurance.js";
const GapMedicalComponent = createComponent({
  tagName: "gap-medical",
  elementClass: GapMedical,
  react: React,
  events: {
    offerStateChange: "offer-state-change"
  }
});
const SeasonInterruptionComponent = createComponent({
  tagName: "season-interuption",
  elementClass: SeasonInterruption,
  react: React,
  events: {
    offerStateChange: "offer-state-change"
  }
});
const RegistrationCancellationComponent = createComponent({
  tagName: "registration-cancellation",
  elementClass: RegistrationCancellation,
  react: React,
  events: {
    offerStateChange: "offer-state-change"
  }
});
const TuitionInsuranceComponent = createComponent({
  tagName: "tuition-insurance",
  elementClass: TuitionInsurance,
  react: React,
  events: {
    offerStateChange: "offer-state-change"
  }
});
const TravelInsuranceComponent = createComponent({
  tagName: "travel-insurance",
  elementClass: TravelInsurance,
  react: React,
  events: {
    offerStateChange: "offer-state-change"
  }
});
const MultiOfferWrapperElementComponent = createComponent({
  tagName: "multi-offer",
  elementClass: MultiOfferWrapperElement,
  react: React,
  events: {
    offerStateChange: "offer-state-change"
  }
});
const PetInsuranceComponent = createComponent({
  tagName: "pet-insurance",
  elementClass: PetInsurance,
  react: React,
  events: {
    offerStateChange: "offer-state-change"
  }
});
const ShippingInsuranceComponent = createComponent({
  tagName: "shipping-insurance",
  elementClass: ShippingInsurance,
  react: React,
  events: {
    offerStateChange: "offer-state-change"
  }
});
const TicketRefundComponent = createComponent({
  tagName: "ticket-refund",
  elementClass: TicketRefund,
  react: React,
  events: {
    offerStateChange: "offer-state-change"
  }
});
export {
  GapMedicalComponent,
  MultiOfferWrapperElementComponent,
  PetInsuranceComponent,
  RegistrationCancellationComponent,
  SeasonInterruptionComponent,
  ShippingInsuranceComponent,
  TicketRefundComponent,
  TravelInsuranceComponent,
  TuitionInsuranceComponent
};
